import { DeliveryInsight, DeliveryOrderType, DeliveryType } from 'apis/merchant-gateway/insights';

export type DeliveryInsightTotals = Record<DeliveryType, Record<'regular' | 'preorder', number>>;

const createInsightOrderTotalGetter =
  (deliveryInsightData?: DeliveryInsight) => (deliveryType: DeliveryType, orderType: DeliveryOrderType) =>
    deliveryInsightData?.data.delivery.split
      ?.find(({ label }) => label === deliveryType)
      ?.split?.find(({ label }) => label === orderType)?.total?.orders ?? 0;

export const getInsightsOrderTotalsByDeliveryType = (deliveryInsightData?: DeliveryInsight) => {
  const getInsightTotalForTypes = createInsightOrderTotalGetter(deliveryInsightData);

  return {
    homedelivery: {
      regular: getInsightTotalForTypes('homedelivery', 'INSTANT'),
      preorder: getInsightTotalForTypes('homedelivery', 'PREORDER'),
    },
    takeaway: {
      regular: getInsightTotalForTypes('takeaway', 'INSTANT'),
      preorder: getInsightTotalForTypes('takeaway', 'PREORDER'),
    },
    eatin: {
      regular: getInsightTotalForTypes('eatin', 'INSTANT'),
      preorder: getInsightTotalForTypes('eatin', 'PREORDER'),
    },
  };
};
